import styled from "styled-components";

export const MessageContainer = styled.article`
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: var(--box-shadow1);
  border-radius: var(--border-radius-1);
  margin: 1.5rem;
  color: var(--blue-color-dark);
  font-size: var(--font-size-sm);
  & p:nth-child(2) {
    margin: 0;
  }
  img {
    max-height: 150px;
    object-fit: contain;
  }
  .danger {
    color: var(--danger-color);
  }
  .success {
    color: var(--success-color);
  }

  time {
    font-size: var(--font-size-xs);
  }
  figure.star-icon {
    position: relative;
    margin-bottom: 0;
    margin-left: 12px;
    .score {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: var(--font-size-xs);
      font-weight: 700;
      color: var(--dark-color);
    }
  }
`;

export const UserMessage = styled.div`
  img.avatar {
    grid-area: avatar;
  }
  b.username {
    grid-area: username;
  }
  .content {
    grid-area: content;
    max-width: 580px;
  }
  a.report-link {
    grid-area: report-link;
    justify-self: end;
  }
  time.date {
    grid-area: date;
    justify-self: end;
    margin-right: 0.5rem;
  }
  grid-template-areas: "avatar username content report-link date";
  grid-template-columns: 50px max-content auto min-content min-content;
  @media screen and (max-width: 1200px) {
    grid-template-areas:
      "avatar username username username"
      "avatar content content content"
      "avatar  . report-link date";
    grid-template-columns: 50px auto auto min-content;
  }
  a.report-link {
    font-size: var(--font-size-xs);
  }
`;
